import { C as CosmosIconPersonFollowing$1, d as defineCustomElement$1 } from './p-Cqc1nyme.js';

const CosmosIconPersonFollowing = CosmosIconPersonFollowing$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPersonFollowing, defineCustomElement };
